// extracted by mini-css-extract-plugin
export default {"generate-report":"styles_generate-report__tokVT"};